// Page-growing playbook shown in FB Studio → Hướng dẫn. Learned from the team's Viral Studio pages.
export const FB_GUIDE = [
    {
        title: '1. Quy trình mỗi ngày',
        items: [
            'Sáng: xem tab Insight + tin nhắc Zalo — page nào chưa đăng, page nào đang lên.',
            'Tạo nội dung: chọn master prompt hoặc prompt bạn sưu tầm → AI gợi ý ý tưởng → AI viết prompt → tạo ảnh/video.',
            'Tự xem kết quả: lỗi hình, lệch tỉ lệ, kết thúc dở dang thì tạo lại. Đạt thì TẢI VỀ NGAY (link ảnh/video hết hạn sau vài ngày).',
            'Đăng tay lên page. Page trong BM của team tự đồng bộ bài & số liệu — bạn chỉ cần bấm "Gắn prompt" cho bài. Page ngoài BM thì ghi bài và cập nhật view sau 1 và 7 ngày.',
            'Page đang lên: đăng 2–3 bài/ngày cùng chủ đề đang ăn khách để giữ đà.'
        ]
    },
    {
        title: '2. Ý tưởng phải WOW',
        items: [
            'Một chủ thể lớn, rõ, gây "ồ" ngay 2 giây đầu. Lá rơi, tuyết, ánh sáng chỉ là trang trí, không phải điểm wow.',
            'Mỗi video chỉ MỘT điều kỳ lạ, mọi thứ khác bình thường như đời thật.',
            'Thử kể ý tưởng bằng 1 câu cho bạn bè nghe. Nghe nhạt, rối, hay "làm dở dang" thì đổi ý tưởng.',
            'Video quá trình (xây, sửa, dọn) phải ra KẾT QUẢ hoàn chỉnh và có người dùng/ở trong đó ở cuối clip.',
            'Video động vật: con vật tự do, bình yên, chỉ âm thanh tự nhiên — không người, không lời thoại.'
        ]
    },
    {
        title: '3. Prompt ảnh & video',
        items: [
            'Ảnh: một đoạn 80–170 từ — chủ thể → bối cảnh thật → góc máy/ống kính → ánh sáng → phong cách. Viết điều muốn thấy, không liệt kê điều cấm.',
            'Ảnh làm khung mở đầu video: chụp chủ thể TRƯỚC khi điều kỳ diệu xảy ra, không phải kết quả.',
            'Video: không nhân vật thật/người nổi tiếng, thương hiệu, vũ khí, máu, trẻ em là nhân vật chính — hệ thống sẽ từ chối (lượt được hoàn).',
            'Số lượng & hình dáng vật cố định: tối đa 3 con/cái mỗi loại, mô tả 1 lần và giữ nguyên.',
            'Không ưng thì dùng "AI tối ưu" kèm nhận xét cụ thể (VD: "kết thúc bị đứng hình", "con chim bị nhân đôi").'
        ]
    },
    {
        title: '4. Caption & đăng bài',
        items: [
            'Caption như người thật: 1 dòng ngắn, kể hoặc đùa nhẹ. Ít đặt câu hỏi, tối đa 1 emoji.',
            'Không viết "Ever wondered…", "Imagine…", "Let us know below" — nghe như AI.',
            'Không nói là cảnh quay thật, không tin giả, không giật tít.',
            'Giờ vàng US/EU: 7–9h sáng và 19–22h tối giờ VN (sáng/tối bên kia) — thử và xem Insight để chọn giờ riêng cho page.',
            'Trả lời bình luận vài chữ, tự nhiên; không hỏi ngược lại.'
        ]
    },
    {
        title: '5. Test chủ đề',
        items: [
            'Page mới: ưu tiên reel/video; ảnh tối đa 1/lô cho tới khi có tương tác.',
            'Thử chủ đề mới vài bài → chủ đề nào nổ thì dồn bài vào chủ đề đó, nhưng vẫn thử chủ đề mới song song.',
            'Trend/lễ chỉ làm khi hợp ngách: đăng thử 1 bài trước, ăn khách mới làm thêm.',
            'Học Bảng vàng: xem prompt của bài thắng, áp khung đó cho ngách của bạn.',
            'Page 3 tuần không lên: đổi chủ đề hoặc tạm dừng (trạng thái "Tạm dừng" để không bị nhắc).'
        ]
    },
    {
        title: '6. Hạn mức & hàng chờ',
        items: [
            'Hạn mức ngày (mặc định 15 video, 30 ảnh) chỉ tính kết quả trả về hợp lệ. Lỗi, bị từ chối, chưa máy nào nhận sau 40 phút hoặc đang làm mà quá 3 giờ → tự hoàn lượt. Video đang tạo lâu thì đừng bấm tạo lại — sẽ ra 2 bản trùng.',
            'Mỗi người chạy tối đa 2 job tạo ảnh/video cùng lúc; tạo thêm thì job nằm trong hàng chờ HopeTeam và tự chạy khi có slot. Giữ tab mở để hàng chờ chạy tiếp.',
            'Huỷ job đang chờ (nút thùng rác trong Thư viện) → hoàn lượt ngay.',
            'Hạn mức làm mới lúc 0h giờ VN. Cần thêm thì báo admin.',
            'Prompt của tôi: lưu prompt sưu tầm được (tiếng gì cũng được), chỉ bạn thấy — AI học khung rồi viết bản mới an toàn.'
        ]
    }
];
